import { OptionType } from 'v2/form/CustomSelectors/GeneralSelect';
import { ProposalRejectionOptionRole } from 'v2/models';
import { useProposalRejectionOptions } from 'v2/queries';

export enum ExtraProposalRejectionOption {
  other = 'other',
}

const otherOption: OptionType<ExtraProposalRejectionOption.other> = {
  label: 'Other',
  value: ExtraProposalRejectionOption.other,
};

type ProposalRejectionOptionType = OptionType<
  number | ExtraProposalRejectionOption.other
>;

export function useProposalRejectionSelectOptions() {
  const query = useProposalRejectionOptions({
    role: ProposalRejectionOptionRole.data_provider,
  });
  const { data: proposalRejectionOptions } = query;

  const options: ProposalRejectionOptionType[] | undefined =
    proposalRejectionOptions?.map(({ id, text }) => ({
      label: text,
      value: id,
    }));

  options?.push(otherOption);

  return {
    ...query,
    data: options ?? [],
  };
}
